import React, { Component } from 'react';
import DrawEntryList from './DrawEntryList';

export default class DrawEntry extends Component{
    constructor(){
        super()
    }

    render(){
        return(
            <div className="row">
                <article className="col-xs-12">
                    <div className="jarviswidget" id="wid-id-0" data-widget-editbutton="false">
                        <header>
                            <span className="widget-icon"> <i className="fa fa-gear"></i> </span>
                            <h2><strong>Draw</strong> <i>Entry</i></h2>
                        </header>
                        <div>
                            <div className="jarviswidget-editbox"></div>
                            <div id="terminalCon" className="widget-body">
                                <DrawEntryList />
                            </div>                            
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}